import {nextTick} from "vue";
import {useStore} from "vue2-helpers/vuex";

export default function () {
    const store = useStore();

    const showNeedUpgrade = function (type) {
        store.commit('showNeedUpgrade', type);

        nextTick(() => {
            store.commit('showNeedUpgrade', false);
        })
    }

    return {showNeedUpgrade}
}
